import { DEV } from 'cc/env';
import { _decorator, SpriteFrame } from 'cc';
import MultiThemeSprite from '../MultiTheme/MultiThemeSprite';
import OrientedComponent, { OrientedBaseProperty } from './OrientedComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('OrientedMultiThemeSpriteProperties')
class OrientedMultiThemeSpriteProperties extends OrientedBaseProperty {
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整 MultiThemeSprite 的圖片列表 ' })
    public updateMultiThemeSpriteFrames: boolean = false;
    @property({
        type: [SpriteFrame],
        tooltip: DEV && 'MultiThemeSprite 的圖片列表',
        visible(this: OrientedMultiThemeSpriteProperties) {
            return this.updateMultiThemeSpriteFrames;
        },
    })
    public multiThemeSpriteFrames: SpriteFrame[] = [];
}

@ccclass('OrientedMultiThemeSprite')
@requireComponent(MultiThemeSprite)
@menu('Orientation/OrientedMultiThemeSprite')
export default class OrientedMultiThemeSprite extends OrientedComponent<MultiThemeSprite> {
    @property({ type: OrientedMultiThemeSpriteProperties, group: '橫式' })
    public readonly landscapeProperties: OrientedMultiThemeSpriteProperties = null;
    @property({ type: OrientedMultiThemeSpriteProperties, group: '直式' })
    public readonly portraitProperties: OrientedMultiThemeSpriteProperties = null;

    protected updateOrientationProperties(properties: OrientedMultiThemeSpriteProperties) {
        if (properties.updateMultiThemeSpriteFrames) {
            this.target.replaceSpriteFrames(properties.multiThemeSpriteFrames);
        }
    }

    protected getTarget() {
        return this.getComponent(MultiThemeSprite);
    }
}
